<template>
  <div class="wrapper">
    <div
      class="profile-field__title"
      :class="{
        'profile-field__title--required': field.required,
      }"
    >
      Паспортные данные
    </div>

    <div class="row">
      <div class="col col-6 col-md-2 series">
        <div class="form-group">
          <c-input
            v-model="series"
            floating-label="Серия"
            :clearable="true"
            :max-length="255"
            :invalid="!!errors.common || !!errors.series"
            :error="errors.series"
          />
        </div>
      </div>
      <div class="col col-6 col-md-2 number">
        <div class="form-group">
          <c-input
            v-model="number"
            floating-label="Номер"
            :clearable="true"
            :max-length="255"
            :invalid="!!errors.common || !!errors.number"
            :error="errors.number"
          />
        </div>
      </div>
      <div class="col col-12 col-md-5 issued-by">
        <div class="form-group">
          <c-input
            v-model="issuedBy"
            floating-label="Кем выдан"
            :clearable="true"
            :max-length="255"
            :invalid="!!errors.common || !!errors.issuedBy"
            :error="errors.issuedBy"
          />
        </div>
      </div>
      <div class="col col-6 col-md-2 col-lg-3 col-xl-2 date">
        <div class="form-group">
          <c-input
            ref="date"
            v-model="issueDate"
            type="date"
            placeholder="00.00.0000"
            label="Дата выдачи"
            icon="calendar"
            :editable="true"
            :selects="true"
            :clearable="true"
            :icon-right="true"
            :invalid="errors.common || errors.issueDate"
            :error="errors.issueDate"
          />
        </div>
      </div>
    </div>

    <error-feedback v-if="error && error.common" :text="error && error.common" />
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";
import ErrorFeedback from "@/components/error-feedback";

export default {
  components: { CInput, ErrorFeedback },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      series: "",
      number: "",
      issuedBy: "",
      issueDate: "",
    };
  },

  computed: {
    errors() {
      return this.error || {};
    },
  },

  watch: {
    series() {
      this.updateValue();
    },
    number() {
      this.updateValue();
    },
    issuedBy() {
      this.updateValue();
    },
    issueDate() {
      this.updateValue();
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
    
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      const { series, number, issuedBy, issueDate } = value.value || {};

      this.series = series || "";
      this.number = number || "";
      this.issuedBy = issuedBy || "";
      this.issueDate = issueDate || "";

      if (this.$refs.date) {
        this.$refs.date.setDateInputTypeDate(this.issueDate);
      }
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateValue() {
      this.$emit("input", {
        value: {
          series: this.series,
          number: this.number,
          issuedBy: this.issuedBy,
          issueDate: this.issueDate,
        },
      });
      if (this.inited) this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";
@import "~@/assets/styles/grid.scss";

.wrapper {
  margin-bottom: -24px;

  @include beforeBootstrapMd {
    @include narrowGrid();
  }
  @include bootstrapMd {
    @include gridGenerator(10);
  }
  @include bootstrapLg {
    @include gridGenerator(12);
  }
}

.date {
  padding-top: 6px;
}
</style>
